/**
 * description 共享到已定稿库弹框
 * created by tanyaohua
 * created on 2020-0610
 */
'use strict';
angular.module('shareToYdModule', []).controller('shareToYdCtrl', [
    '$scope',
    '$modalInstance',
    '$validation',
    'modalDialog',
    'trsHttpService',
    'incomeParams',
    'trsspliceString',
    function($scope, $modalInstance, $validation, modalDialog, trsHttpService, incomeParams, trsspliceString) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {};
            $scope.data = {
                items: 0, // 用来拦截未选中的情况
            };
            $scope.itemsSd = [];
            // 初始化稿件分类已选数组
            $scope.mClassSelected = {};
        }

        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            getMClassification();
        }

        /**
         * [getMClassification description] 获取稿件分类
         * @return  {[type]}  [return description]
         */
        function getMClassification() {
            var params = {
                serviceid: 'mlf_sharedoc',
                methodname: 'getYDShareCategory',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                for (var i = 0; i < data.length; i++) {
                    if (!data[i].CHILDLIST) {
                        data[i].CHILDLIST = [];
                    }
                }
                $scope.mClassification = data;
            });
        }

        /**
         * [close description] 取消
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };

        // 选择分类开始
        $scope.selectMClass = function(item) {
            if (!angular.isDefined($scope.mClassSelected[item.ID])) {
                $scope.mClassSelected[item.ID] = item;
                $scope.data.items++;
            } else {
                delete $scope.mClassSelected[item.ID];
                $scope.data.items--;
            }
        };
        
        /**
         * [confirm description] 确定
         * @return {[type]} [description]
         */
        $scope.confirm = function () {
            if ($scope.data.items) {
                var shareToCats = '';
                angular.forEach($scope.mClassSelected, function(value, key) {
                    shareToCats += key + ',';
                });
                shareToCats = shareToCats.substring(0, shareToCats.length - 1);
                var params = angular.copy(incomeParams);
                params.shareToCats = shareToCats;
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.ISSUCCESS == 'true') {
                        modalDialog.alertType('稿件共享成功', '', 'success', false, function() {
                            $modalInstance.close('success');
                        });
                    }
                });
            } else {
                modalDialog.saveModel('共享失败', '请选择要共享到的稿库', 'error');
            }
        };
    },
]);
